import { axiosInstance } from "../axios/axiosConfig";
import { USER_API } from "../constants/api-constants";

export const postChangeLanguage = async (payload) => {
    try {
        const response = await axiosInstance.post(USER_API.POST_CHANGE_LANGUAGE, payload);
        return response.data;
    } catch (error) {
        return error;
    }
};

export const postChangeCurrency = async (payload) => {
    try {
        const response = await axiosInstance.post(USER_API.POST_CHANGE_CURRENCY, payload);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getValidateEmail = async (email) => {
    try {
        const response = await axiosInstance.get(`${USER_API.GET_VALIDATE_EMAIL_API}/${encodeURIComponent(email)}`);
        return response.data;
    } catch (error) {
        return error;
    }
};

export const getValidateId = async (id) => {
    try {
        const response = await axiosInstance.get(`${USER_API.GET_VALIDATE_ID_API}/${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}
